import { useQuery } from "@tanstack/react-query";

import { TOOL_REGISTRY_KEY } from "./cache-utils";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface ToolRegistryListItem {
  id: number;
  name: string;
  updated_at: string;
}

interface ListToolRegistriesResponse {
  success: boolean;
  tool_registries: ToolRegistryListItem[];
}

export const useListToolRegistries = (workspaceId: number | null) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: [TOOL_REGISTRY_KEY, "list", workspaceId],
    queryFn: async (): Promise<ListToolRegistriesResponse> => {
      if (!workspaceId) {
        throw new Error("Missing workspace ID");
      }
      const res = await fetch(ENDPOINTS.tool_registry.list(workspaceId), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!userToken,
  });
};
